import React from "react";
import TripleProgressLineFlex from "../../../components/singleComponenets/TripleProgressLineFlex";

const CaseComparison = ({ caseComparison = [] }) => {
  if (!Array.isArray(caseComparison) || caseComparison.length === 0) {
    return (
      <div className="text-white">
        <div className="flex justify-between">
          <span className="text-xl font-bold">
            Compare between Entered, Opened & Signed
          </span>
        </div>
        <div className="w-full bg-[#555] my-5 h-0.5" />
        <div className="text-[#555]">No comparison data available</div>
      </div>
    );
  }

  return (
    <div className="text-white">
      <div className="flex justify-between">
        <span className="text-xl font-bold">
          Compare between Entered, Opened & Signed
        </span>
        <div className="flex gap-4 mt-4 text-sm">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-[#5A3EFF] block rounded-full"></span>{" "}
            Entered
          </div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-[#00A3FF] block rounded-full"></span>{" "}
            Opened
          </div>
          <div className="flex items-center gap-2">
            <span className="w-3 h-3 bg-[#9747FF] block rounded-full"></span>{" "}
            Signed
          </div>
        </div>
      </div>

      <div className="w-full bg-[#555] my-5 h-0.5" />

      <div className="grid md:grid-cols-2 gap-10">
        {caseComparison.map((c, i) => (
          <TripleProgressLineFlex
            key={c.siteName || i}
            site={c.siteName || "Unknown Site"}
            total={c.total || 0}
            entered={c.entered || 0}
            opened={c.opened || 0}
            signed={c.signed || 0}
          />
        ))}
      </div>
    </div>
  );
};

export default CaseComparison;
